/**
 * The Settings panel, grouped the way Intercom groups it: Home loose at the
 * top, then one collapsible group per domain, with the two single-page
 * surfaces (Tola AI) loose between them.
 *
 * Each group is its own builder module, registered here in display order and
 * spread into the `settings` product area by `../index.js`. Adding a group means
 * adding a module and a line in this array - nothing else changes.
 */
import buildHome from './home';
import buildWorkspace from './workspace';
import buildSubscription from './subscription';
import buildChannels from './channels';
import buildInbox from './inbox';
import buildTolaAi from './tola-ai';
import buildData from './data';
import buildIntegrations from './integrations';
import buildPersonal from './personal';

export const SETTINGS_BUILDERS = [
  buildHome,
  buildWorkspace,
  buildSubscription,
  buildChannels,
  buildInbox,
  buildTolaAi,
  buildData,
  buildIntegrations,
  buildPersonal,
];
